import React from 'react';

import { PortfolioDetails } from 'core/lib/modules/portfolio';

export const PortfolioDetailsContext = React.createContext<PortfolioDetails | Partial<PortfolioDetails> | null>(null);
